import {TimePickerUtils} from 'wix-ui-core/time-picker';

export const isValidEndOfDayTimeString = timeStr => timeStr === '24:00' || timeStr === '24:00:00' || timeStr === '24:00:00.000';

export const isValidRangeTimeString = time => isValidEndOfDayTimeString(time) || TimePickerUtils.isValidTime(time);

export const isTimeIn24HourRange = timeStr => {
  if (!timeStr) {
    return false;
  }

  const hoursOutOfFormatRangeRegex = /^([3-9][0-9]|[2][4-9]):([0-5][0-9])$/;
  const minutesOutOfRangeRegex = /^([0-1][0-9]|2[0-3]):([6-9][0-9])$/;

  return isValidEndOfDayTimeString(timeStr) || (!hoursOutOfFormatRangeRegex.test(timeStr) && !minutesOutOfRangeRegex.test(timeStr));
};

export const isEndTimeAfterStartTime = (startTime, endTime) => {
  // We dont want to return invalid for reason other then endTime > startTime reasons
  if (!endTime || !startTime || !isValidRangeTimeString(endTime) || !isValidRangeTimeString(startTime)) {
    return true;
  }

  return endTime > startTime;
};

